// extracted by mini-css-extract-plugin
export default {"Checkbox":"Checkbox-module--Checkbox--f8ff0","Checkbox__checkmark":"Checkbox-module--Checkbox__checkmark--bb005"};